<!-- <div class="fixed-top custombg" style=" z-index: 100;">
  <div class="d-flex flex-column">
    <app-header #header></app-header>
    <app-breadcrumb></app-breadcrumb>
  </div>
</div> -->
<div class="wrapper">
  <div class="toggle-container" *ngIf="_isManager && showmydashboardbutton">
    <button 
      class="toggle-tab" 
      [ngClass]="{'active': viewName === 'My Dashboard'}" 
      (click)="setView('My Dashboard')">
      My Dashboard
    </button>
    <button 
      class="toggle-tab" 
      [ngClass]="{'active': viewName === 'Team Dashboard'}" 
      (click)="setView('Team Dashboard')">
      Team Dashboard
    </button>
  </div>
  <div class="row" [ngClass]="_isManager ? '': 'mt-2'">
    <div class="col-lg-8 pr-0 pb-3">
      <!-- <div class=" border-radius"> -->
      <app-profile-card
        [programRequestsCount]="_programRequestsCount"
        [overallTeamPrograms]="_overallTeamPrograms"
        [overallTeamCompletedPrograms]="_overallTeamCompletedPrograms"
        [teamprogramRequestsCount]="_teamPendingRequestCount"
        [isManager]="_isManager"
        [isViewTeamDashboard]="isViewTeamDashboard"
        [totalProjects]="_totalProjects"
        [empReporting]="_empReporting"
        [shadowEmps]="_shadowEmps"
        [billableEmps]="_billableEmps"
        [empsProjectStatus]="_empsProjectStatus"
        [userEmpId]="employeeId">
      </app-profile-card>


      <!-- </div> -->
    </div>
    <div class="col-lg-4 pb-3">
      <!-- <div class="announce border-radius" > -->
      <app-announcements [isManager]="_isManager" [topLearners]="_topLearners" [teamTopLearners]="_teamTopLearners"
        [isViewTeamDashboard]="isViewTeamDashboard"></app-announcements>
      <!-- </div> -->
    </div>
    <div class="col-lg-8 pr-0">
      <!-- <div class="border-radius"> -->
      <app-learnings *ngIf="!isViewTeamDashboard" [learnings]="_learnings" [programProgress]="_programProgress"
        [totalCoursesOfEmp]="_totalCoursesOfEmp"></app-learnings>
      <app-team-learnings *ngIf="isViewTeamDashboard"></app-team-learnings>
      <!-- </div> -->
    </div>
    <div class="col-lg-4">
      <!-- <div class="border-radius"> -->
      <app-learn-next *ngIf="!isViewTeamDashboard" [nextLearnings]="_nextLearnings"></app-learn-next>
      <app-team-progress *ngIf="isViewTeamDashboard"></app-team-progress>
      <!-- </div> -->
    </div>
  </div>
</div>
